import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogService, NotificationService } from '@nrwl/common-lib';
import { DataSourceService } from '../../service/datatsource.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'nrwl-transfer-device',
  templateUrl: './transfer-device.component.html',
  styleUrls: ['./transfer-device.component.scss']
})
export class TransferDeviceComponent implements OnInit {
  action: string;
  transferEsamsList: string[] = [];
  transferJmepsSourceId: string;
  transferJmepName: string;
  transferJmepsList: string[] = [];
  selectedEsamName: string;
  enableForceOption = false;
  actionInProgress = false;
  transferDeviceJSON: any;
  selectedJmepToTransfer = [];
  isLoading = false;
  transferSucceeded = false;
  maximumTransferLimit = 2000;

  private readonly unsubscribe: Subject<void> = new Subject();
  constructor(
    private notificationService: NotificationService,
    private dialogRef: MatDialogRef<TransferDeviceComponent>,
    private uiCommService: DataSourceService,
    private dialogService: DialogService,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    // eslint-disable-next-line no-console
    this.handleTransfer();
  }

  handleTransfer(): void {
    const selectedJmeps = this.data.data;
    if (selectedJmeps.length > this.maximumTransferLimit) {
      this.action = 'not-remove-all';
      this.dialogService.showInfo(
        'information',
        'body',
        'Only 2000 JMEPs can be transferred at a time, Please reduce the number of JMEPs selected.',
        'Error - Exceeds Max Transfer limit'
      );
      this.closeDialog();
    } else if (this.validateSelectedJmep(selectedJmeps[0]?.dataItem)) {
      this.setupTransfer(selectedJmeps);
    } else {
      this.action = 'no-esams';
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  validateSelectedJmep(jmep: any): boolean {
    return jmep.capabilities?.phy?.['esam-guid'];
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setupTransfer(selectedJmeps: any): void {
    this.action = 'transfer';
    this.transferEsamsList = [];
    this.transferJmepsSourceId = selectedJmeps[0]?.dataItem?.capabilities?.phy['esam-guid'];
    this.transferJmepName =
      this.data.data.length === 1 ? selectedJmeps[0]?.dataItem?.deviceName : '';
    //this.selectedJmepToTransfer.push(this.data.data.dataItem.id);
    this.selectedJmepToTransfer = this.data.data.map(item => item.dataItem.id);
    this.transferJmepsList = this.selectedJmepToTransfer;

    this.data.deviceList.forEach(device => {
      if (device.model.model === 'ESAM' && device.id !== this.transferJmepsSourceId) {
        this.transferEsamsList.push(device.name);
      }
    });

    if (!this.transferEsamsList.length) {
      this.action = 'no-esams';
    } else {
      this.action = 'transfer';
      this.selectedEsamName = this.transferEsamsList[0];
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  transferConfirmation(item: any): void {
    const params = {
      id: 'datasource.transfer',
      alternateTitle: `Transfer to ${this.transferEsamsList[0]}?`, //${this.transferJmepsList.length} device(s) will be transferred
      callBackFnParams: item,
      callBackService: this,
      callBackFuntion: this.callBackTransferFunction
    };
    this.dialogService.showDialog('confirm', 'body', params);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  callBackTransferFunction(service: any, params: any): void {
    this.isLoading = true;
    service.startTransfer(params);
  }

  transferJMEPs(): void {
    const destinationId = this.getDestinationId();

    if (destinationId) {
      this.transferConfirmation(destinationId);
    } else {
      this.closeDialog();
      this.notificationService.onFail(
        `JMEP Transfer failed. Cannot find ID for selected ESAM: ${this.selectedEsamName}`
      );
    }
  }

  getDestinationId(): string | null {
    const destination = this.data.deviceList.find(device => device.name === this.selectedEsamName);
    return destination ? destination.id : null;
  }

  startTransfer(destinationId: string): void {
    this.actionInProgress = true;
    this.transferDeviceJSON = {
      esamDestinationName: this.selectedEsamName,
      data: {
        sourceesam: {
          additionalProp1: {
            jmep: this.transferJmepsList,
            id: this.transferJmepsSourceId
          }
        },
        destinationesamid: destinationId
      }
    };

    const requestData = {
      forceOption: this.enableForceOption,
      obj: this.transferDeviceJSON
    };

    this.uiCommService
      .transferDevices(requestData)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          if (response.status === 'success') {
            this.transferSucceeded = true;
            this.isLoading = false;
            this.closeDialog();
            this.notificationService.onSuccess(
              this.transferJmepName
                ? `JMEP ${this.transferJmepName} has been transferred successfully. Please wait for few minutes.`
                : 'All JMEPs were transferred successfully.'
            );
          } else if (this.enableForceOption) {
            this.isLoading = false;
            this.closeDialog();
            this.notificationService.onFail(
              this.transferJmepName
                ? `Failed to transfer ${this.transferJmepName}: ${response.data.message}`
                : `Failed to transfer all JMEPs: ${response.data.message}`
            );
          }
        },
        () => {
          this.isLoading = false;
          this.enableForceOption = true;
          this.startTransfer(this.getDestinationId());
        }
      );
  }

  closeDialog(): void {
    const returnObj = [
      {
        transferStatus: this.transferSucceeded
      }
    ];
    this.dialogRef.close(returnObj);
  }
}
